import { classNames } from '../../../../common/lib/classNames';
import { getContactInitials } from '../lib/agentDisplay';

export function ContactAvatar({ name, alert }: { name?: string | null; alert?: boolean }) {
  return (
    <div
      className={ classNames(
        `flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-semibold`,
        alert ? `bg-orange-100 text-orange-700` : `bg-paidniceGreen-100 text-paidniceGreen-700`,
      ) }
    >
      { getContactInitials(name) }
    </div>
  );
}
